import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { LoginService } from '../../../../shared-modules/login/login.service';

@Component({
    selector: 'app-e-form-pdf-name',
    templateUrl: './e-form-pdf-name.component.html',
    //styleUrls: ['./e-form-pdf-name.component.scss']
})
export class EFormPdfNameComponent implements OnInit {

    PDFName: string
    V10:boolean;
    constructor(
        private dialogRef: MatDialogRef<EFormPdfNameComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private loginService: LoginService,
    ) {

    }

    ngOnInit() {
        this.PDFName = this.data.PDFName;
        this.V10 = this.loginService.LoginSettings.V10;
    }

    nextClick() {
        this.dialogRef.close(this.PDFName);
    }

}
